import Page from "./Page";
import EarthDemo from "../util/EarthDemo";
import planetgame from "../../images/planetgame.png";

export default function CurrentFocus() {
  return (
    <Page>
      <div className="page-header">
        <h1 className="titleFont">Current Projects</h1>
      </div>
      <div className="section-wrapper">
        <p className="lead">
          My current focus is honing my skills of incorporating AI into my full
          stack projects, and using it to streamline my development process,
          allowing me to fully focus on deepening my understanding of concepts
          and frameworks. Below are a combination of projects I have worked on,
          some for practice, others for fun and learning.
        </p>
        <div className="section-flex-wrapper gap">
          <div className="small-section-wrapper gap-large">
            <div className="section-flex-item">
              <div className="titleFont">AGU'A NO BICO</div>
              <div>
                This is a site that I built for a friend of mine who is creating
                discussions in the architecture scene in Portugal and
                throughtout Europe. This site allows for groups of architects to
                get together and discuss principles and ideas they find from a
                small group of images each week. Utilized Firebase Storage and
                Remote Config to allow for them to maintain the images and make
                changes to the text as they wish.
              </div>
              <a
                href="https://aguanobico.com"
                target="_blank"
                rel="noopener noreferrer"
                className="link titleFont"
              >
                CHECKOUT AGU'A NO BICO
              </a>
            </div>
            <div className="section-flex-item">
              <p>
                This is a project I am currently working on, it is a library
                site that allows users to interact with small parts of books
                that I have read and want to share.
              </p>
              <a
                href="https://library.gorillian.dev"
                target="_blank"
                rel="noopener noreferrer"
                className="link titleFont"
              >
                CHECKOUT MY LIBRARY SITE
              </a>
            </div>
          </div>
          <div className="section-wrapper">
            <EarthDemo />
            <div>Learning ThreeJS: click and drag to rotate the earth</div>
          </div>
          <div className="section-flex-item">
            <div className="titleFont">SwiftUI projects:</div>
            <div>
              Stack and merge style game built in SwiftUI that is the space
              themed version of the game I play more than I care to admit.
              Working to get it on the App Store, stay tuned.
            </div>
            <video
              className="planet-game-clip"
              src="/planet-merge.mp4"
              poster={planetgame}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
            />
          </div>
        </div>
      </div>
    </Page>
  );
}
